import { render, staticRenderFns } from "./UserLogHistory.vue?vue&type=template&id=f2078246&scoped=true&"
import script from "./UserLogHistory.vue?vue&type=script&lang=js&"
export * from "./UserLogHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserLogHistory.vue?vue&type=style&index=0&id=f2078246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2078246",
  null
  
)

export default component.exports